<template>
  <table>
    <tr v-if="fullShow">
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr v-if="fullShow">
      <td><label>{{ $t('generic.type') }}</label></td>
      <td>{{ details.type }}</td>
    </tr>
    <tr v-if="fullShow">
      <td><label>{{ $t('cardDetails.trait') }}</label></td>
      <td>{{ details.trait }}</td>
    </tr>
    <tr v-if="fullShow">
      <td><label>{{ $t('generic.status') }}</label></td>
      <td>{{ details.status }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('cardDetails.public_id') }}</label></td>
      <td class="font-weight-bold">{{ details.public_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('cardDetails.serial_number') }}</label></td>
      <td>{{ details.serial_number }}</td>
    </tr>
    <tr v-if="fullShow">
      <td><label>{{ $t('cardDetails.serial_number_hash') }}</label></td>
      <td>{{ details.serial_number_hash }}</td>
    </tr>
    <tr v-if="fullShow">
      <td><label>{{ $t('cardDetails.account_id') }}</label></td>
      <td>
        <router-link v-if="details.account_id" :to="accountLinkUrl(details.account_id)">{{
            details.account_id
          }}
        </router-link>
      </td>
    </tr>
    <tr v-if="fullShow">
      <td><label>{{ $t('cardDetails.issued_at') }}</label></td>
      <td><span v-if="details.issued_at"> {{ details.issued_at | time }}</span></td>
    </tr>
    <tr v-if="fullShow">
      <td><label>{{ $t('cardDetails.validity_ends_at') }}</label></td>
      <td><span v-if="details.validity_ends_at"> {{ details.validity_ends_at | time }}</span></td>
    </tr>
    <tr v-if="fullShow">
      <td><label>{{ $t('cardDetails.warranty_ends_at') }}</label></td>
      <td><span v-if="details.warranty_ends_at"> {{ details.warranty_ends_at | time }}</span></td>
    </tr>
    <tr v-if="fullShow">
      <td><label>{{ $t('generic.createdBy') }}</label></td>
      <td>{{ details.created_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr v-if="fullShow">
      <td><label>{{ $t('generic.updatedBy') }}</label></td>
      <td>{{ details.modified_by }}</td>
    </tr>
    <tr v-if="fullShow">
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
  </table>
</template>
<script>
import linkUtils from "@/util/link_utils";

export default {
  name: 'cardDetails',
  components: {},
  props: {
    details: {
      type: Object,
      required: true,
    },
    fullShow: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    accountLinkUrl(id) {
      return linkUtils.accountProfilePath(this.$router, {account_id: id});
    },
  }
};
</script>
<style></style>
